<template>
  <div class="box my-card">
    <img class="my-image" v-bind:id="id" v-bind:src="currentSrc" />
    <nav
      class="pagination is-right is-small my-pagination"
      role="navigation"
      aria-label="pagination"
    >
      <a class="pagination-previous" v-on:click="goPrevious">Previous</a>
      <a class="pagination-next" v-on:click="goNext">Next</a>
      <ul class="pagination-list">
        <li>
          <a class="pagination-link" aria-label="First Page" v-on:click="goPage(1)">1</a>
        </li>
        <li>
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li v-if="previousPage >= 0">
          <a class="pagination-link" v-on:click="goPrevious">{{previousPage}}</a>
        </li>
        <li>
          <a
            class="pagination-link is-current"
            v-bind:aria-label="'Page' + this.currentIndex + 1"
            aria-current="page"
          >{{currentPage}}</a>
        </li>
        <li v-if="nextPage > 0">
          <a class="pagination-link" v-on:click="goNext">{{nextPage}}</a>
        </li>
        <li>
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li>
          <a
            class="pagination-link"
            aria-label="Last Page"
            v-on:click="goPage(numberImages)"
          >{{numberImages}}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    goNext() {
      if (this.currentIndex < this.numberImages - 1) {
        this.currentIndex += 1;
      }
    },
    goPrevious() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
      }
    },
    goPage(page) {
      this.currentIndex = page - 1;
    },
  },
  computed: {
    numberImages() {
      return this.images.length;
    },
    currentSrc() {
      return this.images[this.currentIndex];
    },
    currentPage() {
      return this.currentIndex + 1; // conversion to 1-based index
    },
    nextPage() {
      const nextImage = this.currentIndex + 1;
      if (nextImage < this.numberImages) {
        const nextPage = nextImage + 1;
        return nextPage;
      }
      return 0;
    },
    previousPage() {
      const previousImage = this.currentIndex - 1;
      if (previousImage >= 0) {
        const previousPage = previousImage + 1;
        return previousPage;
      }
      return -1;
    },
  },
  props: {
    id: String,
    images: Array,
  },
};
</script>

<style>
</style>
